import { Record } from 'immutable';

import { ChartListEntity } from '../components/chart-list/chart-list.entity';

export const ChartSliceKey = 'main';

export interface IChartOriginalSliceState {
	loading: boolean;
	list: ChartListEntity;
	includePublicProjects: boolean;
	deleteSuccess: boolean;
}

export const defaults: IChartOriginalSliceState = {
	loading: false,
	list: ChartListEntity.build([]),
	includePublicProjects: false,
	deleteSuccess: false,
};

export class ChartOriginalSliceState extends Record<IChartOriginalSliceState>(
	defaults
) {
	public static readonly key = ChartSliceKey;

	public setLoading(isLoading: boolean): ChartOriginalSliceState {
		return this.set('loading', isLoading);
	}

	public setChartList(chartList: ChartListEntity): ChartOriginalSliceState {
		return this.set('list', chartList);
	}

	public setDeleteSuccess(isSuccess: boolean): ChartOriginalSliceState {
		return this.set('deleteSuccess', isSuccess);
	}

	public toggleIncludePublicProjects(
		includePublicProjects: boolean
	): ChartOriginalSliceState {
		return this.set('includePublicProjects', includePublicProjects);
	}
}
